/**
 *
 * @/functions/fbuserprofile.js
 *
 * Description:
 * Provisory useful functions to read user profile from firebase RTDB
 *
 */

export const isValidObject = obj => !!obj === true && typeof obj === 'object' && Array.isArray(obj) === false

export const extractUserRawPhone = u => {
  try {
    const DDD = String(u?.ddd ?? "").replace(/[^0-9]/g, "")
    const PHONE = String(u?.tel ?? "").replace(/[^0-9]/g, "")
    return DDD.length === 2 && (PHONE.length === 8 || PHONE.length === 9) ? `${DDD}${PHONE}` : ""
  } catch { return "" }
}

export const extractUserRawCpf = u => {
  try {
    const RAW_CPF = String(u?.cpf ?? "").replace(/[^0-9]/g, "")
    return RAW_CPF.length === 11 ? RAW_CPF : ""
  } catch { return "" }
}

export const extractUserRawCnpj = u => {
  try {
    const RAW_CNPJ = String(u?.cnpj ?? "").replace(/[^0-9]/g, "")
    return RAW_CNPJ.length === 14 ? RAW_CNPJ : ""
  } catch { return "" }
}
